import React from 'react';
import type BasePageProps from '@internal/pages/BasePageProps';
import {FormGrid} from '@internal/components';
import CMSHeadScriptsAPI from '@internal/apis/CMSHeadScriptsAPI';

const FormScript: React.FC<BasePageProps> = ({navigatePage, urlParams}) => {
  const [loading, setLoading] = React.useState(false);
  const [key, setKey] = React.useState(Date.now());
  const formConfig = React.useRef<any>([
    {
      name: 'name',
      label: 'Script Name',
      fieldType: 'input',
      isRequired: true,
      validations: {
        type: 'input',
        required: true,
        customMessages: {
          required: "name can't be blank.",
        },
      },
    },
    {
      name: 'script',
      label: 'Script with on or multiple <script> tags',
      fieldType: 'textarea',
      isRequired: true,
      validations: {
        type: 'input',
        required: true,
        customMessages: {
          required: "script can't be blank.",
        },
      },
    },
  ]);
  const record = React.useRef<any>();

  React.useEffect(() => {
    if (urlParams.id) {
      void reloadFunc().then();
    }
  }, []);
  const reloadFunc = async (): Promise<void> => {
    setLoading(true);
    record.current = await CMSHeadScriptsAPI.get(
      navigatePage,
      urlParams.id ?? '',
    );
    for (let i = 0; i < formConfig.current.length; i++) {
      formConfig.current[i].value = record.current[formConfig.current[i].name];
    }
    setLoading(false);
    setKey(Date.now());
  };
  const handleFormSubmit = async (data: any) => {
    setLoading(true);
    if (urlParams.id) {
      await CMSHeadScriptsAPI.update(navigatePage, record.current, data);
    } else {
      await CMSHeadScriptsAPI.save(navigatePage, data);
    }
    setLoading(false);
  };
  return (
    <React.Fragment key={key}>
      <FormGrid
        fields={formConfig.current ?? []}
        onSubmit={handleFormSubmit}
        submitButtonText={urlParams.id ? 'Update' : 'Save'}
        doShowCardHeader
        reloadFunc={urlParams.id ? reloadFunc : undefined}
        title={urlParams.id ? 'Update Page' : 'New Page'}
        loading={loading}
      />
    </React.Fragment>
  );
};

export default FormScript;
